
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/hospitals/neighborhood",
      function () {
        return require("private-next-pages/hospitals/neighborhood/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/hospitals/neighborhood"])
      });
    }
  